import { getTranslationManually } from "src/helpers/locale";

export function copyText(textCopy) {
  const el = document.createElement("textarea");
  el.value = textCopy;
  document.body.appendChild(el);
  el.select();
  document.execCommand("copy");
  document.body.removeChild(el);
}

export function isValidURL(urlString) {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i"
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
}

/**
 * Mask text by last 3 digits (by default)
 */
export function maskText(text, maskCount = 3) {
  if (!text) return "";

  const textLength = text.length;

  const lastDigits = text.slice(-maskCount);
  const maskedDigits = "*".repeat(textLength - maskCount);

  return maskedDigits + lastDigits;
}

export function ellipseMiddleText(text = "", max = 16) {
  if (text.length > max) {
    return text.substring(0, max - 3) + "..." + text.substring(text.length - 3, text.length);
  }
  return text;
}

/**
 *
 * @param {*} inputString
 * @returns
 * example:
 * const inputString = ".png, .jpg, .jpeg, .pdf"
 * const result = formatExtensions(inputString, true)
 * console.log(result) // Output: "PNG, JPG, JPEG or PDF"
 */
export function formatExtensions(inputString, withConjunction = false) {
  const extensions = inputString.split(",").map((ext) => ext.trim().replace(".", "").toUpperCase());

  if (withConjunction) {
    const lastExtension = extensions.pop();
    return extensions.length
      ? `${extensions.join(", ")} ${getTranslationManually("atau", "or")} ${lastExtension}`
      : lastExtension;
  }
  return extensions.join(", ");
}
